var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import ferpaIcon from '../../icons/ferpa.png';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-ri5qtd" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var FerpaIcon = styled.img.withConfig({ displayName: "FerpaIcon", componentId: "sc-junsy3" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-right: 32px;\n"], ["\n  margin-right: 32px;\n"])));
var H2 = styled.h2.withConfig({ displayName: "H2", componentId: "sc-1wv8ikm" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 164px;\n  font-size: 18px;\n  line-height: 24px;\n  color: #777b8b;\n  margin: 0;\n  font-weight: bold;\n"], ["\n  width: 164px;\n  font-size: 18px;\n  line-height: 24px;\n  color: #777b8b;\n  margin: 0;\n  font-weight: bold;\n"])));
var FerpaItem = function (_a) {
    var rest = __rest(_a, []);
    return (_jsxs(Container, __assign({}, rest, { children: [_jsx(FerpaIcon, { src: ferpaIcon, alt: 'ferpa' }, void 0), _jsx(H2, { children: "COPPA, FERPA, AB1584 Compliant" }, void 0)] }), void 0));
};
export { FerpaItem };
var templateObject_1, templateObject_2, templateObject_3;
